import { Star, ExternalLink } from "lucide-react";
import { GOOGLE_PROFILE_URL } from "../../lib/site";
import { Reveal, SectionTag } from "./Reveal";

// Real Google reviews (as provided by owner)
const REVIEWS = [
  {
    author: "Shane Denman",
    rating: 5,
    text: "A honest and professional scrap metal recycling business, has courtesy and knowledge of the metals industry and pays top prices to customers.",
  },
  {
    author: "Emili Clark",
    rating: 5,
    text: "Very professional and not one to rip you off like all these other places. Highly recommend taking your scrap here.",
  },
  {
    author: "Chris Fout",
    rating: 5,
    text: "This is my go to place anytime I have any kind of scrap metal I want to recycle. The staff is excellent.",
  },
];

export const Reviews = () => (
  <section className="bg-white py-20 sm:py-24" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag number="06" label="Reviews" />
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <h2 className="font-heading text-4xl sm:text-5xl text-zinc-950 tracking-tight">WHAT CUSTOMERS SAY</h2>
          <a
            href={GOOGLE_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-zinc-700 hover:text-red-700 transition-colors shrink-0"
            data-testid="reviews-see-all-link"
          >
            See all 13 reviews on Google
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </Reveal>

      {REVIEWS.length === 0 ? (
        <Reveal delay={0.1}>
          <div className="mt-12 border border-zinc-200 bg-zinc-50 p-10 sm:p-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6" data-testid="reviews-placeholder">
            <div>
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-zinc-300" />
                ))}
              </div>
              <p className="font-heading text-2xl text-zinc-950 tracking-wide">GOOGLE REVIEWS COMING SOON</p>
              <p className="mt-2 text-zinc-600 text-sm">Sold scrap with us? Leave us a review on Google.</p>
            </div>
            <a
              href={GOOGLE_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border-2 border-zinc-950 text-zinc-950 px-6 py-3 font-heading tracking-wider hover:bg-zinc-950 hover:text-white transition-colors shrink-0"
              data-testid="reviews-google-link"
            >
              FIND US ON GOOGLE
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </Reveal>
      ) : (
        <div className="mt-12 grid md:grid-cols-3 gap-4">
          {REVIEWS.slice(0, 3).map((r, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="border border-zinc-200 bg-white p-8 h-full flex flex-col hover:border-zinc-950 transition-colors" data-testid={`review-card-${i}`}>
                <div className="flex gap-1 mb-4">
                  {[...Array(r.rating)].map((_, j) => (
                    <Star key={j} className="h-4 w-4 text-red-700 fill-red-700" />
                  ))}
                </div>
                <p className="text-zinc-700 leading-relaxed flex-1">"{r.text}"</p>
                <div className="mt-6 flex items-center justify-between border-t border-zinc-100 pt-4">
                  <p className="font-heading tracking-wide text-zinc-950">{r.author}</p>
                  <span className="text-[11px] font-bold uppercase tracking-wider text-zinc-400">Google Review</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  </section>
);
